export function toPrice(value: unknown): number | null {
    const num = Number(value);
    return Number.isFinite(num) && num > 0 ? num : null;
}

export function formatUnitPriceRange(min: unknown, max: unknown): string | null {
    const lo = toPrice(min);
    const hi = toPrice(max);
    if (lo == null && hi == null) return null;
    if (lo != null && hi != null) {
        if (lo === hi) return lo.toFixed(2);
        return `${lo.toFixed(2)} - ${hi.toFixed(2)}`;
    }
    return (lo ?? hi)!.toFixed(2);
}

export function formatSupplierUnitPrice(price: unknown): string | null {
    const value = toPrice(price);
    return value != null ? value.toFixed(2) : null;
}
